// extracted by mini-css-extract-plugin
export default {"link":"Footer_link__sgKeT","mailLink":"Footer_mailLink__1ZTLU","flexLink":"Footer_flexLink__W-6FZ"};